// extracted by mini-css-extract-plugin
module.exports = {"user":"style_user__3y6Zf","user-avatar":"style_user-avatar__1tlK-","info":"style_info__3r_GB","email":"style_email__2-Nm8","light-box-image":"style_light-box-image__1PycV"};